var React = require('react');

function ArrowFromRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 88v336a23.94 23.94 0 0 1-24 24h-16a23.94 23.94 0 0 1-24-24V88a23.94 23.94 0 0 1 24-24h16a23.94 23.94 0 0 1 24 24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M193.48 391.87l-17 17.06a23.86 23.86 0 0 1-33.91 0L7.05 273a24 24 0 0 1 0-34l135.52-135.93a23.86 23.86 0 0 1 33.91 0l17 17.06a24 24 0 0 1 0 34l-65.61 65.81H328A24 24 0 0 1 352 244v24.08a24 24 0 0 1-24 24.07H127.87L193.48 358a23.9 23.9 0 0 1 0 33.87z","className":"fa-primary","key":2})]);
}

ArrowFromRight.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = ArrowFromRight;

ArrowFromRight.default = ArrowFromRight;
